/**
 * Created by AlexanderC on 1/25/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationError = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let ValidationError = exports.ValidationError = function (_Exception) {
  _inherits(ValidationError, _Exception);

  /**
   * @param {String} annotation
   * @param {{message:*,path:*,type:*,context:*}[]} validationErrors
   */
  function ValidationError(annotation, validationErrors) {
    _classCallCheck(this, ValidationError);

    var _this = _possibleConstructorReturn(this, (ValidationError.__proto__ || Object.getPrototypeOf(ValidationError)).call(this, `Payload validation failed: ${annotation}`));

    _this._validationErrors = validationErrors;
    return _this;
  }

  /**
   * @returns {{message:*,path:*,type:*,context:*}[]}
   */


  _createClass(ValidationError, [{
    key: 'validationErrors',
    get: function get() {
      return this._validationErrors;
    }
  }]);

  return ValidationError;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/ValidationError.js
// module id = 426
// module chunks = 0